import { useState } from 'react';
import './Technologies.css';

const techData =
    [
        // Web Development
        { name: 'HTML5', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', category: 'web' },
        { name: 'CSS3', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', category: 'web' },
        { name: 'JavaScript', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', category: 'web' },
        { name: 'TypeScript', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg', category: 'web' },
        { name: 'PHP', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg', category: 'web' },
        { name: 'Python', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg', category: 'web' },
        { name: 'Ruby', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-original.svg', category: 'web' },
        { name: 'Node.js', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', category: 'web' },
        { name: 'React', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', category: 'web' },
        { name: 'Vue.js', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg', category: 'web' },
        { name: 'Next.js', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg', category: 'web' },
        { name: 'Angular', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg', category: 'web' },
        { name: 'Tailwind CSS', image: '/images/icons/icons8-tailwind-css.svg', category: 'web' },
        { name: 'Bootstrap', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg', category: 'web' },

        // Mobile Development
        { name: 'Flutter', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg', category: 'mobile' },
        { name: 'Dart', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg', category: 'mobile' },
        { name: 'Swift', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg', category: 'mobile' },
        { name: 'Kotlin', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg', category: 'mobile' },
        { name: 'React Native', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', category: 'mobile' },
        { name: 'Java', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg', category: 'mobile' },

        // Database

        { name: 'MySQL', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg', category: 'database' },
        { name: 'MongoDB', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg', category: 'database' },
        { name: 'Redis', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg', category: 'database' },
        { name: 'SQLite', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg', category: 'database' },



        { name: 'AWS', image: '/images/icons/icons8-aws-logo.svg', category: 'devops' },
        { name: 'Azure', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg', category: 'devops' },
        { name: 'Google Cloud', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg', category: 'devops' },
        { name: 'Firebase', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg', category: 'devops' },




    ]


const tabs = [
    { label: 'All', category: 'all' },
    { label: 'Website Development', category: 'web' },
    { label: 'Databases', category: 'database' },
    { label: 'Cloud & DevOps', category: 'devops' },
    { label: 'Mobile Apps', category: 'mobile' }
];

export default function Technologies() {
    const [activeTab, setActiveTab] = useState('all');

    const filteredTech = activeTab === 'all' ? techData : techData.filter(t => t.category === activeTab);

    return (
        <center>
            <section className="tech-section">
                <center>
                    <p className="text-uppercase fw-bold">Explore the solutions we offer to grow your business.</p>
                    <h2 className="section-title">
                        Our <span className="blue-text">Technologies</span>
                    </h2>
                    <br />
                </center>
                <div className="tabs">
                    {tabs.map(tab => (
                        <button
                            key={tab.category}
                            className={`tab-button ${activeTab === tab.category ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.category)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="tech-grid">
                    {filteredTech.map(tech => (
                        <div className="tech-item" key={tech.name}>
                            <img src={tech.image} alt={tech.name} />
                            <div className="tech-label">{tech.name}</div>
                        </div>
                    ))}
                </div>
            </section>
        </center>
    );
}
